<app-signature-request-status
  [signatureRequests]="signatureRequests()"
></app-signature-request-status>
<div>
  @if (latestSignatureRequest) {
    <span matTooltip="Demande créée le">
      <svg lucideRocket></svg>
      {{ latestSignatureRequest.createdAt | date: 'dd/MM/yyyy' }}
    </span>
    @if (isExpired) {
      <span matTooltip="Expirée le">
        <svg lucideCircleX></svg>
        {{ latestSignatureRequest.expiresAt | date: 'dd/MM/yyyy' }}
      </span>
    } @else if (isSigned) {
      <span matTooltip="Date de signature">
        <svg lucideSignature></svg>
        {{ latestSignatureRequest.signedAt | date: 'dd/MM/yyyy' }}
      </span>
    } @else {
      <span matTooltip="Date d'expiration">
        <svg lucideCalendarX></svg>
        {{ latestSignatureRequest.expiresAt | date: 'dd/MM/yyyy' }}
      </span>
    }
  }
</div>
